import { render, staticRenderFns } from "./CameraBox.vue?vue&type=template&id=750541a3&"
import script from "./CameraBox.vue?vue&type=script&lang=js&"
export * from "./CameraBox.vue?vue&type=script&lang=js&"
import style0 from "./CameraBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports